module.exports = __webpack_public_path__ + "static/media/golfer-2-b.604ea83e.png";